import { ContestWithUserAccount } from '@monorepo/types';

export type ContestCategoryDetails = {
  title: string;
  subTitle?: React.ReactNode;
  contests: ContestWithUserAccount[];
};

export type ContestCategories = ContestCategoryDetails[];

export enum ContestPageSegments {
  leaderboard = 'Leaderboard',
  prizes = 'Prizes',
  rules = 'Rules',
}

export enum ContestDashboardSegments {
  info = 'Info',
  balance = 'Balance',
  trades = 'Trades',
  stats = 'Stats',
}

export type ContestPaginateFilter = {
  contestId?: string;
  name?: string;
};
